import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {update} from "../../../app/setters/update.js";

export const useEdytujTag = () => {

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => update(`/rejestr/tag`, data),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },

        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['tagi_lista'],
            });
        },

        onSuccess: ({message}) => {
            toast.success(message)
        }
    })
}